import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { getCatalogDisableFilters } from 'store/ProductCatalog/controls/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function DisableFilterContainer({ children, disableFilters }) {
  return (
    <>
      {disableFilters ?
        <div className={cx('container')}>
          <div className={cx('overlay')} />
          {children}
        </div>
      : <div>{children}</div>}
    </>
  );
}

DisableFilterContainer.propTypes = {
  children: PropTypes.node,
  disableFilters: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  disableFilters: getCatalogDisableFilters(state),
});

export default connect(mapStateToProps)(DisableFilterContainer);
